export const PHASES = {
  RESOLVING: 'resolving',
  ESTIMATING: 'estimating',
  COMPLETE: 'complete'
};

export const BATCH_SIZE = 6;

// Simulated loading bar ticker (PRO41-1941): keeps the agent-phase progress creeping
// upward during a long interactWithAgent wait instead of sitting flat while it's in
// flight. +7% every 5s, capped at 70 (i.e. ~95% combined with the 0-25% product phase)
// until the real interactWithAgent responses actually finish.
export const SIMULATED_LOADING_BAR_TICK_MS = 5000;
export const SIMULATED_LOADING_BAR_INCREMENT = 7;
export const SIMULATED_LOADING_BAR_CAP = 70;
